import { WorkflowTriggerType } from 'src/graphql/entities/workflow/workflow.trigger';

/**
 * Portal-side mirror of the backend `WorkflowEmergencyOverrideConfig`
 * (`business-layer/domain/workflow/get-workflow-emergency-override.ts`), stored as a JSON
 * string in the `workflow_emergency_override` platform setting value.
 */
export interface TriggerEmergencyOverride {
  workflowId?: string;
  enabled?: boolean;
}

export interface WorkflowEmergencyOverrideConfig {
  /** Flips every trigger at once. */
  master?: boolean;
  triggers?: Partial<Record<WorkflowTriggerType, TriggerEmergencyOverride>>;
}

export const EMPTY_WORKFLOW_EMERGENCY_OVERRIDE_CONFIG: WorkflowEmergencyOverrideConfig = {};
